import type { Node, NodeId, QueryView } from "~/models/dto";
import { ImmutableMap } from "~/tools/immutable-map";

export type NodeMap<T extends Node> = ImmutableMap<NodeId, T>;

export interface GlobalState {
	queryViews: NodeMap<QueryView>;
}

export const initialGlobalState: GlobalState = {
	queryViews: ImmutableMap.empty<NodeId, QueryView>(),
};
